import React, { useEffect, useState, useRef } from "react"
import "../components/header.scss"
import logoDesktop from "../images/LOGO_THEME_DESKTOP.svg"
import logoMobile from "../images/LOGO_THEME_MOBILE.svg"
import { StaticImage } from "gatsby-plugin-image"
import financials2021 from "../images/PJM_2021_Financials.pdf"
import TransitionLink from 'gatsby-plugin-transition-link'
import AniLink from "gatsby-plugin-transition-link/AniLink";
import useWindowDimensions from '../hooks/useWindowDimensions'
import { gsap } from "gsap"
import downloadIcon from "../images/download.svg"


export default function Header() {
    const { width, height } = useWindowDimensions();
    const [isMobile, setIsMobile] = useState();
    const logoRow = useRef();
    const burger = useRef();
    const burgerMenu = useRef();
    const [logo, setLogo] = useState(logoDesktop);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const timeline = useRef();

    useEffect(() => {
        if(width > 1024) {
            setIsMobile(false);
        } else {
            setIsMobile(true);
        }
    }, [width]);

    function handleBurgerClick() {
        if(isMenuOpen) {
            closeBurgerMenuWithoutNavClick()
        } else {
            openBurgerMenu();
        }
    }

    function openBurgerMenu() {
        setIsMenuOpen(true);
        timeline.current = gsap.timeline()
        .to(burgerMenu.current, {height: (height - 63), duration: .5, ease: "power2"})
    }
    
    function closeBurgerMenu() {
        setIsMenuOpen(false);
        if(document.querySelectorAll('.has-scroll-smooth').length > 0) {
            let html = document.querySelector('.has-scroll-init.has-scroll-smooth');
            html.classList.remove('has-scroll-init');
            html.classList.remove('has-scroll-smooth');
        }
        timeline.current = gsap.timeline()
        .to(burgerMenu.current, {height: 0, duration: .5, ease: "power2"});

        
    }
	function closeBurgerMenuWithoutNavClick() {
		setIsMenuOpen(false);
		timeline.current = gsap.timeline()
        .to(burgerMenu.current, {height: 0, duration: .5, ease: "power2"});
	}

    return (
        <header className="header">
            <div className="row" ref={logoRow}>
                <div className="col-xs-12">
                    <div className="row full-width-row">
                        <div className="col-xs-10 col-md-6 logo-col">
                            <TransitionLink
                                to="/"
                                exit={{
                            
                                }}
                                entry={{
                                }}
                            >
                                { !isMobile &&
                                   <img src={logoDesktop} alt="" className="logo" />
                                }
                                { isMobile &&
                                   <img src={logoMobile} alt="" className="logo" />
                                }
                            </TransitionLink>
                        </div>
                        <div className="col-xs-2 col-md-6">
                            { !isMobile && 
                                <div className="download-wrap">
                                    <a onClick={()=> window.open(financials2021, "_blank")} className={"download"}>
                                        <div className="icon">
                                            <img src={downloadIcon} alt=""/>
                                        </div>
                                        <div className="info">
                                            <div className="text--blue">Financial Report</div>
                                        </div>
                                    </a>
                                </div>
                            }
                            { isMobile && 
                                <div onClick={handleBurgerClick} className="burger" ref={burger}>
                                    <button className={"hamburger hamburger--collapse " + (isMenuOpen ? "is-active" : null)} type="button">
                                      <span className="hamburger-box">
                                        <span className="hamburger-inner"></span>
                                      </span>
                                    </button> 
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            { isMobile && 
                <div ref={burgerMenu}  className="row bg-blue mobile-menu">
                    <div className="col-xs-12">
                        <nav>
                            <ul>
                                <li>
                                    <AniLink onClick={closeBurgerMenu} fade to='/welcome' duration={1.3}>WELCOME</AniLink>
                                </li>
                                <li>
                                    <AniLink onClick={closeBurgerMenu} fade to='/board-ceo-letters' duration={1.3}>Board & CEO Letters</AniLink>
                                </li>
                                <li>
                                    <AniLink onClick={closeBurgerMenu} fade to='/officers' duration={1.3}>Officers</AniLink>
                                </li>
                                <li>
                                    <AniLink onClick={closeBurgerMenu} fade to='/operations' duration={1.3}>Operations</AniLink>
                                </li>
                                <li>
                                    <AniLink onClick={closeBurgerMenu} fade to='/markets' duration={1.3}>Markets</AniLink>
                                </li>
                                <li>
                                    <AniLink onClick={closeBurgerMenu} fade to='/reliability' duration={1.3}>Reliability & Resilience</AniLink>
                                </li>
                                <li>
                                    <AniLink onClick={closeBurgerMenu} fade to='/planning' duration={1.3}>Planning</AniLink>
                                </li>
                                <li>
                                    <AniLink onClick={closeBurgerMenu} fade to='/risk-management' duration={1.3}>Risk Management</AniLink>
                                </li>
                                
                                <li>
                                    <AniLink onClick={closeBurgerMenu} fade to='/innovation' duration={1.3}>Innovation</AniLink>
                                </li>
                               
                                <li>
                                    <AniLink onClick={closeBurgerMenu} fade to='/culture-of-caring' duration={1.3}>Culture of Caring</AniLink>
                                </li>
                                <li>
                                    <div className="download-wrap-mobile">
                                        <a onClick={()=> window.open(financials2021, "_blank")} className={"download"}>
                                            <div className="icon">
                                                <img src={downloadIcon} alt=""/>
                                            </div>
                                            <div className="info">
                                                <div className="text--blue">Financial Report</div>
                                            </div>
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            }
            <div className="phone-orientation">
                <div>Please turn your phone to portrait orientation.</div>
            </div>
        </header>
    )
}